import { RouteObject, Outlet, Navigate } from 'react-router-dom';
import type { RouterProps } from 'contracts/Router';
import {
  VehicleTypesListPage,
  VehicleTypeCreationPage,
  VehicleTypeUpdatePage,
} from 'pages/VehicleTypes';

const vehicleTypesRoutes = ({
  location,
  userBelongsToAnyOf,
}: RouterProps): RouteObject => ({
  path: 'configuracoes/tipos-veiculos',
  element: userBelongsToAnyOf('admin') ? (
    <Outlet />
  ) : (
    <Navigate to="/" state={{ from: location }} />
  ),
  children: [
    {
      path: '',
      element: <VehicleTypesListPage />,
    },
    {
      path: 'criar',
      element: <VehicleTypeCreationPage />,
    },
    {
      path: ':id/editar',
      element: <VehicleTypeUpdatePage />,
    },
  ],
});

export default vehicleTypesRoutes;
